function handleClick (rootNode: HTMLElement, functionName: void, event: MouseEvent) {
  const { target } = event;
  if (target !== rootNode && !rootNode.contains(target)) {
    functionName();
  }
}

export function startListening (rootNode, functionName) {
  if (document) {
    document.body.addEventListener('click', (event) => handleClick(rootNode, functionName, event), { passive: true });
  }
}

export function stopListening (rootNode, functionName) {
  if (document) {
    document.body.removeEventListener('click', (event) => handleClick(rootNode, functionName, event));
  }
}
